import { ToastContainer, toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import { Link } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";

export default function ContactUs() {
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientNo, setClientNo] = useState("");
  const [clientMssg, setClientMssg] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    let newErrors = {};
    if (!clientName) newErrors.clientName = "Name is required";
    if (!clientEmail) newErrors.clientEmail = "Email is required";
    if (!clientNo) newErrors.clientNo = "Contact number is required";

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`/api/WebEnquiry`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clientName, clientEmail, clientNo, clientMssg }),
      });

      const data = await response.json();
      response.ok ? toast.success(data.message) : toast.error(data.error);

      if (response.ok) {
        setClientName("");
        setClientEmail("");
        setClientNo("");
        setClientMssg("");
        setErrors({});
      }
    } catch {
      toast.error("Something went wrong");
    }
    setIsSubmitting(false);
  };

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <>
      <section className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center" data-aos="zoom-in">
          <h1 className="text-4xl md:text-5xl font-bold">
            Contact Us
          </h1>
          <p className="mt-3 text-blue-100">
            We’re here to help you with admissions & queries
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-14">

        <div className="space-y-8" data-aos="fade-right">
          <div className="csection-title">
            <h2 className="text-2xl font-semibold text-red-600">Get in Touch</h2>
            <p className="text-gray-600 mt-2">Reach out to us for admissions, academics or general enquiries.</p>
          </div>


          <div className="flex gap-4 bg-white rounded-xl shadow p-4" data-aos="fade-up" data-aos-delay="100">
            <div className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold">
              <i className="bi bi-geo-alt-fill fs-6"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-800">Address</h4>
              <p className="text-gray-600 text-sm">NH-2A, Mugal Road, Sikandra, Kanpur Dehat, Uttar Pradesh – 209125</p>
            </div>
          </div>
          <div className="flex gap-4 bg-white rounded-xl shadow p-4" data-aos="fade-up" data-aos-delay="200">
            <div className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold">
              <i className="bi bi-envelope-at-fill fs-6"></i> 
            </div>
            <div>
              <h4 className="font-semibold text-gray-800">Email</h4>
              <p className="text-gray-600 text-sm"><Link className='nav-link' to="mailto:kpssikandra@gmail.com">kpssikandra@gmail.com</Link></p>
            </div>
          </div>
          <div className="flex gap-4 bg-white rounded-xl shadow p-4" data-aos="fade-up" data-aos-delay="300">
            <div className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold">
              <i className="bi bi-telephone-outbound-fill fs-6"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-800">Phone</h4>
              <p className="text-gray-600 text-sm"><Link className='nav-link' to="tel:+916306089776">+91 630 608 9776, +91 638 856 7798</Link></p>
            </div>
          </div>


          <div className="rounded-2xl overflow-hidden shadow-lg h-72" data-aos="zoom-in" data-aos-delay="400">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2788.3753173738623!2d79.63872692469735!3d26.356310870245505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399d938b4dc2f999%3A0x159f0858135e94e9!2sKrishna%20Public%20School!5e1!3m2!1sen!2sin!4v1771329929829!5m2!1sen!2sin" title="map" className="w-full h-full" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> 
          </div>
        </div>

        <div className="bg-white shadow-2xl rounded-3xl p-8" data-aos="fade-left">
          <h3 className="text-2xl font-semibold text-red-600 text-center mb-6">Send Us a Message</h3>
          <div className="space-y-5" data-aos="fade-up" data-aos-delay="100">
            <TextField label="Full Name" variant="outlined" fullWidth value={clientName} onChange={(e) => setClientName(e.target.value)} error={!!errors.clientName} helperText={errors.clientName}/>

            <TextField label="Email Address" variant="outlined" fullWidth value={clientEmail} onChange={(e) => setClientEmail(e.target.value)} error={!!errors.clientEmail} helperText={errors.clientEmail}/>

            <TextField label="Contact Number" variant="outlined" fullWidth value={clientNo} onChange={(e) => setClientNo(e.target.value)} error={!!errors.clientNo} helperText={errors.clientNo} />

            <TextField label="Message" variant="outlined" fullWidth multiline rows={4} value={clientMssg} onChange={(e) => setClientMssg(e.target.value)}/>

            <Button type="submit" variant="contained" fullWidth onClick={handleSubmit}
              sx={{ py: 1.5, borderRadius: "12px", fontWeight: 600, backgroundColor: "#ff4e1c", "&:hover": { backgroundColor: "#FFD54F" },}}>
                Send Message
            </Button>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

